import { useColorStore } from '@/store-pinia/colors';

export default {
  methods: {
    getColorTranslation(colorId) {
      const color = useColorStore().color(colorId);
      if (color && color.key) {
        return this.$t(`customization.colors.${color.key}`);
      }
      return '';
    },
    getColorHex(colorId) {
      const color = useColorStore().color(colorId);
      return color && color.hex ? color.hex : null;
    }
  }
};
